import { Box, Button, Card, CardContent, FormControl, Grid, TextField, Typography } from '@mui/material'
import { ArrowLeftCircle, Save } from 'react-feather'
import { CustomAutocomplete } from 'common'

export const QuotationForm = ({ useFetchInit }) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    // Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    // FetchData,
    defaultData,

    //------------- Actions
    Actions
  } = useFetchInit

  // ------------------------------------------------ FetchData

  // ------------------------------------------------ globalStates
  const { modalOpeningMode } = globalStates

  // ------------------------------------------------ actions
  const {
    handleClickHideForm,
    handleChangeTypeLoan,
    handleChangeDownPayment,
    handleChangeMount,
    handleChangeTerm,
    handleChangeGPS,
    handleChangeSeguro,
    handleChangeOtros,
    handleChangeTypeCredit,
    onSubmitFormQuotation
  } = Actions

  // ------------------------------------------------ Helpers

  // ------------------------------------------------ Formularios
  const { FormRequestGlobal } = Forms
  const { formState, onInputChange } = FormRequestGlobal

  return (
    <form onSubmit={onSubmitFormQuotation}>
      <Card style={{ zIndex: '1' }}>
        <CardContent>
          <Typography sx={{ color: 'warning.main' }} variant='overline' >
            * campos obligatorios
          </Typography>
          <div className="border-bottom border-dark"></div>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12} md={2} lg={2}>
              <FormControl fullWidth>
                <label htmlFor="fecha">* Fecha de cotizacion</label>
                <TextField
                  id='fecha'
                  name='fecha'
                  value={formState.fecha}
                  onChange={onInputChange}
                  size='small'
                  hiddenLabel
                  type='date'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <label htmlFor="nombre_cliente">* Nombre del cliente</label>
                <TextField
                  id='nombre_cliente'
                  name='nombre_cliente'
                  value={formState.nombre_cliente}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Nombre del cliente'
                  hiddenLabel
                  type='text'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                  required
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="tipo_cuota">* Tipo de cuota</label>
                <CustomAutocomplete
                  customId="tipo_cuota"
                  customName="tipo_cuota"
                  customValue={formState.tipo_cuota}
                  customOnChange={(target, value) => handleChangeTypeCredit({ target: { name: 'tipo_cuota', value: value.value } })}
                  customPlaceholder='Selecciona un tipo de cuota'
                  customOptions={
                    defaultData.typesLoans.map(({ value, label }) => ({
                      value: value,
                      name: label
                    }))
                  }
                  customDisableClearable={true}
                  customDisabled={(modalOpeningMode === 'READONLY') ? true : false}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <FormControl fullWidth>
                <label htmlFor="monto_venta">* Monto de venta (Q)</label>
                <TextField
                  id='monto_venta'
                  name='monto_venta'
                  value={formState.monto_venta}
                  onChange={handleChangeMount}
                  size='small'
                  placeholder='Monto de venta'
                  hiddenLabel
                  type='text'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                  required
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl fullWidth>
                <label htmlFor="interes">* Tasa de interes mensual</label>
                <TextField
                  id='interes'
                  name='interes'
                  value={formState.interes}
                  onChange={handleChangeTypeLoan}
                  size='small'
                  placeholder='Tipo de interes'
                  hiddenLabel
                  type='number'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                  required
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <FormControl fullWidth>
                <label htmlFor="interes_total">* Interes Anual (%)</label>
                <TextField
                  id='interes_total'
                  name='interes_total'
                  value={formState.interes_total}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Monto de venta'
                  hiddenLabel
                  type='text'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="monto_enganche">* Monto total de enganche (Q)</label>
                <TextField
                  id='monto_enganche'
                  name='monto_enganche'
                  value={formState.monto_enganche}
                  onChange={handleChangeDownPayment}
                  size='small'
                  placeholder='Monto total de enganche'
                  hiddenLabel
                  type='text'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: ((modalOpeningMode === 'READONLY')) ? true : false }}
                  required
                  disabled={formState.tipo_cuota === 'CUOTA LIBRE'}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="enganche">* Porcentaje de enganche (%)</label>
                <TextField
                  id='enganche'
                  name='enganche'
                  value={formState.enganche}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Monto total de enganche'
                  hiddenLabel
                  type='text'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                  disabled={formState.tipo_cuota === 'CUOTA LIBRE'}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="saldo_financiar">* Saldo a financiar (Q)</label>
                <TextField
                  id='saldo_financiar'
                  name='saldo_financiar'
                  value={formState.saldo_financiar}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Saldo a financiar'
                  hiddenLabel
                  type='text'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>

            <Grid item xs={12} sm={12} md={5} lg={5}>
              <FormControl fullWidth>
                <label htmlFor="plazo">* Plazo (Meses)</label>
                <TextField
                  id='plazo'
                  name='plazo'
                  value={formState.plazo}
                  onChange={handleChangeTerm}
                  size='small'
                  placeholder='Plazo (meses)'
                  hiddenLabel
                  type='number'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                  required
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={1} lg={1}></Grid>

            <Grid item xs={12} sm={12} md={5} lg={5}>
              <FormControl fullWidth>
                <label htmlFor="plazo_anios">* Plazo (Años)</label>
                <TextField
                  id='plazo_anios'
                  name='plazo_anios'
                  value={formState.plazo_anios}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Plazo (años)'
                  hiddenLabel
                  type='number'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="gps">* GPS</label>
                <TextField
                  id='gps'
                  name='gps'
                  value={formState.gps}
                  onChange={handleChangeGPS}
                  size='small'
                  placeholder='GPS'
                  hiddenLabel
                  type='text'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="seguro">* Seguro</label>
                <TextField
                  id='seguro'
                  name='seguro'
                  value={formState.seguro}
                  onChange={handleChangeSeguro}
                  size='small'
                  placeholder='Seguro'
                  hiddenLabel
                  type='text'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl fullWidth>
                <label htmlFor="otros">* Otros</label>
                <TextField
                  id='otros'
                  name='otros'
                  value={formState.otros}
                  onChange={handleChangeOtros}
                  size='small'
                  placeholder='Seguro'
                  hiddenLabel
                  type='text'
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12} md={5} lg={5}>
              <FormControl fullWidth>
                <label htmlFor="cuota_niv">* Cuota Nivelada</label>
                <TextField
                  id='cuota_niv'
                  name='cuota_niv'
                  value={formState.cuota_niv}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Cuota Nivelada'
                  hiddenLabel
                  type='text'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                  disabled={formState.tipo_cuota === 'CUOTA LIBRE'}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={1} lg={1}></Grid>

            <Grid item xs={12} sm={12} md={5} lg={5}>
              <FormControl fullWidth>
                <label htmlFor="total_cuota">* Cuota Total</label>
                <TextField
                  id='total_cuota'
                  name='total_cuota'
                  value={formState.total_cuota}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Cuota Total'
                  hiddenLabel
                  type='text'
                  variant='filled'
                  InputProps={{ readOnly: true }}
                  required
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl fullWidth>
                <label htmlFor="descripcion"> Observaciones</label>
                <TextField
                  id='descripcion'
                  name='descripcion'
                  value={formState.descripcion}
                  onChange={onInputChange}
                  size='small'
                  placeholder='Observaciones'
                  hiddenLabel
                  type='text'
                  multiline
                  minRows={4}
                  variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                  InputProps={{ readOnly: (modalOpeningMode === 'READONLY') ? true : false }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Box className="text-center" sx={{ mt: 2 }}>
            <Button
              startIcon={<ArrowLeftCircle />}
              variant="contained"
              type="button"
              className='btn-round'
              color='warning'
              onClick={handleClickHideForm}
              sx={{ marginRight: 1, marginLeft: 1 }}
            >
              Volver
            </Button>

            <Button
              endIcon={<Save />}
              variant="contained"
              className='btn-round'
              color='primary'
              type='submit'
              sx={{ marginRight: 1, marginLeft: 1 }}
            >
              Guardar Cotizacion
            </Button>
          </Box>
        </CardContent>
      </Card>
    </form>
  )
}
